import { useMarkdownStyle } from "../../components/markdown/MarkdownStyleContext";
import { markdownParagraphSize } from "../../components/markdown/markdownSizes";
import { sameNodePosition, } from "../../components/markdown/utils";
import { cn } from "../../lib";
import { cva } from "class-variance-authority";
import React, { memo } from "react";
export const ulBlockVariants = cva(["s-list-disc s-pb-2 s-pl-6"]);
export const UlBlock = memo(({ children }) => {
    const { textColor, forcedTextSize } = useMarkdownStyle();
    const textSize = forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownParagraphSize;
    return (React.createElement("ul", { className: cn(ulBlockVariants(), textColor, textSize) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node));
UlBlock.displayName = "UlBlock";
export const olBlockVariants = cva(["s-list-decimal s-pb-2 s-pl-6"]);
export const OlBlock = memo(({ children, start }) => {
    const { textColor, forcedTextSize } = useMarkdownStyle();
    const textSize = forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownParagraphSize;
    return (React.createElement("ol", { start: start, className: cn(olBlockVariants(), textColor, textSize) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.start === next.start);
OlBlock.displayName = "OlBlock";
export const liBlockVariants = cva(["s-break-words"]);
export const LiBlock = memo(({ children, className }) => {
    const { textColor, forcedTextSize } = useMarkdownStyle();
    const textSize = forcedTextSize !== null && forcedTextSize !== void 0 ? forcedTextSize : markdownParagraphSize;
    return (React.createElement("li", { className: cn(liBlockVariants(), textColor, textSize, className) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) && prev.className === next.className);
LiBlock.displayName = "LiBlock";
//# sourceMappingURL=List.js.map